import { render, staticRenderFns } from "./VideoCoursePeriod.vue?vue&type=template&id=61ad13ec&scoped=true&"
import script from "./VideoCoursePeriod.vue?vue&type=script&lang=js&"
export * from "./VideoCoursePeriod.vue?vue&type=script&lang=js&"
import style0 from "./VideoCoursePeriod.vue?vue&type=style&index=0&id=61ad13ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ad13ec",
  null
  
)

export default component.exports